import { LoginGuardian } from './components/usuario/login/login-guardian-service';


import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SolicitantesComponent } from './components/solicitantes/solicitantes.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { PescadoresComponent } from './components/pescadores/pescadores.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import {NgxPaginationModule} from 'ngx-pagination';
import { ConfirmainfoComponent } from './components/confirmainfo/confirmainfo.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CardtextoComponent } from './components/cardtexto/cardtexto.component';
import { ReglaspescaComponent } from './components/reglaspesca/reglaspesca.component';
import { AboutComponent } from './components/about/about.component';
import { IslascoronadosComponent } from './components/islascoronados/islascoronados.component';
import { OtrodestinoComponent } from './components/otrodestino/otrodestino.component';
import { LoginComponent } from './components/usuario/login/login.component';
import { PrincipalComponent } from './components/principal/principal.component';
import { RegisterComponent } from './components/usuario/register/register.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { LicenciasComponent } from './components/licencias/licencias.component';
import { Ng2LoadingSpinnerModule } from 'ng2-loading-spinner';
import { TablaComponent } from './components/tabla/tabla.component';
import { TablapescadorComponent } from './components/tablapescador/tablapescador.component';
import { LandingComponent } from './components/landing/landing.component';

import { PermisosComponent } from './components/usuario/permisos/permisos.component';
import { SidebarlandingComponent } from './components/sidebarlanding/sidebarlanding.component';
import { GestoresComponent } from './components/gestores/gestores.component';

import { ContactanosComponent } from './components/contactanos/contactanos.component';
import { SidebargestorComponent } from './components/sidebargestor/sidebargestor.component';
import { ReciboComponent } from './components/recibo/recibo.component';




import { PerfectScrollbarModule, PerfectScrollbarConfigInterface,
  PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { ListadoticketgestorComponent } from './components/listadoticketgestor/listadoticketgestor.component';
import { EmailComponent } from './components/email/email.component';
import { FantasmaComponent } from './components/fantasma/fantasma.component';
import { PaypalComponent } from './components/paypal/paypal.component';

import { CopyDirective } from './components/tabla/copy.directive';

import { PoliticasComponent } from './components/politicas/politicas.component';
import { RecibospostComponent } from './components/recibospost/recibospost.component';
import { HistorialComponent } from './components/historial/historial.component';
import { ProyeccionesComponent } from './components/proyecciones/proyecciones.component';


import { RangofechaComponent } from './components/rangofecha/rangofecha.component';
import { CapturaComponent } from './components/usuario/captura/captura.component';
import { CrecimientoComponent } from './components/grafico/crecimiento/crecimiento.component';

import { EditorComponent } from './components/editor/editor.component';

import { AngularEditorModule } from '@kolkov/angular-editor';
import { RedireccionaurlComponent } from './components/redireccionaurl/redireccionaurl.component';
import { FiltradosPipe } from './components/filtrados.pipe';
import { PrepagoComponent } from './components/prepago/prepago.component';
import { PrecomprasComponent } from './components/precompras/precompras.component';
import { FechasPipe } from './pipes/fechas.pipe';
import { MantenimientoComponent } from './components/mantenimiento/mantenimiento.component';
import { UsuarioslanderComponent } from './components/usuario/usuarioslander/usuarioslander.component';
import { CapturalanderComponent } from './components/usuario/capturalander/capturalander.component';
import { MensajeticketComponent } from './components/mensajeticket/mensajeticket.component';
import { ReciboprecompraComponent } from './components/reciboprecompra/reciboprecompra.component';
import { BarcosPipe } from './pipes/barcos.pipe';
import { NgxSpinnerModule } from 'ngx-spinner';

import { SimpleNotificationsModule } from 'angular2-notifications';
import { FiltrosolicitantePipe } from './pipes/filtrosolicitante.pipe';
import { FiltropehistorialPipe } from './pipes/filtropehistorial.pipe';
import { RecibopublicoComponent } from './components/recibopublico/recibopublico.component';
import { NuevousuarioComponent } from './components/usuario/nuevousuario/nuevousuario.component';
import { InventariosComponent } from './components/inventarios/inventarios.component';
import { InventariodialogComponent } from './components/inventariodialog/inventariodialog.component';
import { LotesdialogComponent } from './components/lotesdialog/lotesdialog.component';
import { MuestraprecomprasPipe } from './pipes/muestraprecompras.pipe';
import { CronometroComponent } from './components/cronometro/cronometro.component';
import { CronometrojubotComponent } from './components/cronometrojubot/cronometrojubot.component';
import { UsuariosmxPipe } from './pipes/usuariosmx.pipe';
import { SvglistadospersonComponent } from './components/svglistadosperson/svglistadosperson.component';
import { SvgbarcoComponent } from './components/svgbarco/svgbarco.component';
import { SvgfechasalidaComponent } from './components/svgfechasalida/svgfechasalida.component';
import { SvgformatoComponent } from './components/svgformato/svgformato.component';
import { SvgdayComponent } from './components/svgday/svgday.component';
import { HijoComponent } from './components/hijo/hijo.component';
import { SvgrepetidosComponent } from './components/svgrepetidos/svgrepetidos.component';
import { Bot1Component } from './components/bots/bot1/bot1.component';
import { ListabotPipe } from './pipes/listabot.pipe';
import { AgenciasComponent } from './components/agencias/agencias.component';
import { LicenciasdevComponent } from './components/licenciasdev/licenciasdev.component';
import { PgobancarioComponent } from './components/pgobancario/pgobancario.component';
import { InventariolotesComponent } from './components/inventariolotes/inventariolotes.component';
import { BotadminComponent } from './components/botadmin/botadmin.component';

import { ModalbarcoComponent } from './components/modalbarco/modalbarco.component';
import { ReciboreimpresoComponent } from './components/reciboreimpreso/reciboreimpreso.component';
import { ReciboxeventopreComponent } from './components/reciboxeventopre/reciboxeventopre.component';
import { RecibochequeComponent } from './components/recibocheque/recibocheque.component';
import { GestorprepagoComponent } from './components/gestorprepago/gestorprepago.component';
import { TlicenciagestorPipe } from './pipes/tlicenciagestor.pipe';
import { TipolandingPipe } from './pipes/tipolanding.pipe';
import { UtileriasComponent } from './components/utilerias/utilerias.component';
import { DialograngofechasComponent } from './components/dialograngofechas/dialograngofechas.component';
import { DialogprehistorialComponent } from './components/dialogprehistorial/dialogprehistorial.component';
import { CronometrotiempoComponent } from './components/cronometrotiempo/cronometrotiempo.component';
import { Dialogmensaje3botonesComponent } from './components/dialogmensaje3botones/dialogmensaje3botones.component';
import { UsuariospipeactivosPipe } from './pipes/usuariospipeactivos.pipe';











// hash location






const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true
};







@NgModule({
  declarations: [
    AppComponent,
    CopyDirective,
    SolicitantesComponent,
    PescadoresComponent,
    ConfirmainfoComponent,
    NavbarComponent,
    CarouselComponent,
    CardtextoComponent,
    ReglaspescaComponent,
    AboutComponent,
    IslascoronadosComponent,
    OtrodestinoComponent,
    LoginComponent,
    PrincipalComponent,
    RegisterComponent,
    SidebarComponent,
    LicenciasComponent,
    TablaComponent,
    TablapescadorComponent,
    LandingComponent,
    PermisosComponent,
    SidebarlandingComponent,
    GestoresComponent,

    ContactanosComponent,
    SidebargestorComponent,
    ReciboComponent,
    ListadoticketgestorComponent,
    EmailComponent,
    FantasmaComponent,
    PaypalComponent,
    PoliticasComponent,
    RecibospostComponent,
    HistorialComponent,
    RangofechaComponent,
    ProyeccionesComponent,
    CapturaComponent,
    CrecimientoComponent,
    EditorComponent,
    RedireccionaurlComponent,
    FiltradosPipe,
    PrepagoComponent,
    PrecomprasComponent,
    FechasPipe,
    MantenimientoComponent,
    UsuarioslanderComponent,
    CapturalanderComponent,
    MensajeticketComponent,
    ReciboprecompraComponent,
    BarcosPipe,
    FiltrosolicitantePipe,
    FiltropehistorialPipe,
    RecibopublicoComponent,
    NuevousuarioComponent,
    InventariosComponent,
    InventariodialogComponent,
    LotesdialogComponent,
    MuestraprecomprasPipe,
    CronometroComponent,
    CronometrojubotComponent,
    UsuariosmxPipe,
    SvglistadospersonComponent,
    SvgbarcoComponent,
    SvgfechasalidaComponent,
    SvgformatoComponent,
    SvgdayComponent,
    HijoComponent,
    SvgrepetidosComponent,
    Bot1Component,
    ListabotPipe,
    TipolandingPipe,
    AgenciasComponent,
    LicenciasdevComponent,
    PgobancarioComponent,
    InventariolotesComponent,
    BotadminComponent,
   
    ModalbarcoComponent,
   
    ReciboreimpresoComponent,
   
    ReciboxeventopreComponent,
   
    RecibochequeComponent,
   
    GestorprepagoComponent,
   
    TlicenciagestorPipe,
   
    TipolandingPipe,
   
    UtileriasComponent, DialograngofechasComponent, DialogprehistorialComponent, CronometrotiempoComponent,
    Dialogmensaje3botonesComponent,
    UsuariospipeactivosPipe
      ],

   

  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
    FormsModule,
    NgbModule,
    BrowserAnimationsModule,
    MaterialModule,
    NgxPaginationModule,
    PerfectScrollbarModule,
    Ng2LoadingSpinnerModule.forRoot({}),
    AngularEditorModule,
    NgxSpinnerModule,
    SimpleNotificationsModule.forRoot(),
    
    

    
    
     
    
  
    
    
  










  ],
 
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }, LoginGuardian
  ],
  bootstrap: [AppComponent],
  entryComponents: [ReglaspescaComponent, IslascoronadosComponent, OtrodestinoComponent, ReciboComponent,
    CapturaComponent, EditorComponent, PrecomprasComponent, CapturalanderComponent, MensajeticketComponent,
    ReciboprecompraComponent, NuevousuarioComponent,InventariodialogComponent,LotesdialogComponent,LicenciasdevComponent, PgobancarioComponent, ModalbarcoComponent,ReciboreimpresoComponent,
    ReciboxeventopreComponent, RecibochequeComponent,RangofechaComponent,DialograngofechasComponent, DialogprehistorialComponent, Dialogmensaje3botonesComponent]
})
export class AppModule { }
